export enum RoomRateForms {
  Availability = 'Availability',
  BulkAvailableRates = 'BulkAvailableRates',
}
